import { render, staticRenderFns } from "./Mix.vue?vue&type=template&id=3da0f39c"
import script from "./Mix.vue?vue&type=script&lang=js"
export * from "./Mix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports